import React, { JSX, useState } from 'react';

type SliderTabsProps = {
  children: React.ReactNode[];
  tabsText: Array<string>;
};

const SliderTabs = ({ tabsText, children }: SliderTabsProps): JSX.Element => {
  const [active, setActive] = useState(0);
  return (
    <div className="slider-tabs">
      <div className="tab-buttons" data-active={active}>
        {children.map((_, index) => (
          <button
            className={`${active == index ? 'option selected' : 'option'}`}
            onClick={() => setActive(index)}
            key={`button-${index}`}
          >
            {tabsText[index]}
          </button>
        ))}
      </div>
      {children.map((_, index) => (
        <div
          className={`${active == index ? 'tab-content shown' : 'tab-content'}`}
          key={`tab-${index}`}
        >
          {children[index]}
        </div>
      ))}
    </div>
  );
};

export default SliderTabs;
